/**
 * Auth Constants - Shared constants for authentication forms
 */

export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
  { value: 'DC', label: 'District of Columbia' }
];

export const SPORTS_OPTIONS = [
  { value: 'football', label: 'Football' },
  { value: 'soccer', label: 'Soccer' },
  { value: 'basketball', label: 'Basketball' },
  { value: 'baseball', label: 'Baseball' },
  { value: 'softball', label: 'Softball' },
  { value: 'volleyball', label: 'Volleyball' },
  { value: 'track_field', label: 'Track & Field' },
  { value: 'swimming', label: 'Swimming' },
  { value: 'tennis', label: 'Tennis' },
  { value: 'golf', label: 'Golf' },
  { value: 'wrestling', label: 'Wrestling' },
  { value: 'lacrosse', label: 'Lacrosse' },
  { value: 'hockey', label: 'Hockey' },
  { value: 'cheerleading', label: 'Cheerleading' },
  { value: 'gymnastics', label: 'Gymnastics' },
  { value: 'cross_country', label: 'Cross Country' },
  { value: 'other', label: 'Other' }
];

export const POSITION_OPTIONS = {
  football: [
    { value: 'quarterback', label: 'Quarterback' },
    { value: 'running_back', label: 'Running Back' },
    { value: 'wide_receiver', label: 'Wide Receiver' },
    { value: 'tight_end', label: 'Tight End' },
    { value: 'offensive_line', label: 'Offensive Line' },
    { value: 'defensive_line', label: 'Defensive Line' },
    { value: 'linebacker', label: 'Linebacker' },
    { value: 'cornerback', label: 'Cornerback' },
    { value: 'safety', label: 'Safety' },
    { value: 'kicker', label: 'Kicker' },
    { value: 'punter', label: 'Punter' }
  ],
  soccer: [
    { value: 'goalkeeper', label: 'Goalkeeper' },
    { value: 'defender', label: 'Defender' },
    { value: 'midfielder', label: 'Midfielder' },
    { value: 'forward', label: 'Forward' },
    { value: 'winger', label: 'Winger' }
  ],
  basketball: [
    { value: 'point_guard', label: 'Point Guard' },
    { value: 'shooting_guard', label: 'Shooting Guard' },
    { value: 'small_forward', label: 'Small Forward' },
    { value: 'power_forward', label: 'Power Forward' },
    { value: 'center', label: 'Center' }
  ],
  baseball: [
    { value: 'pitcher', label: 'Pitcher' },
    { value: 'catcher', label: 'Catcher' },
    { value: 'first_base', label: 'First Base' },
    { value: 'second_base', label: 'Second Base' },
    { value: 'shortstop', label: 'Shortstop' },
    { value: 'third_base', label: 'Third Base' },
    { value: 'outfield', label: 'Outfield' }
  ],
  softball: [
    { value: 'pitcher', label: 'Pitcher' },
    { value: 'catcher', label: 'Catcher' },
    { value: 'infield', label: 'Infield' },
    { value: 'outfield', label: 'Outfield' }
  ],
  volleyball: [
    { value: 'setter', label: 'Setter' },
    { value: 'outside_hitter', label: 'Outside Hitter' },
    { value: 'middle_blocker', label: 'Middle Blocker' },
    { value: 'opposite', label: 'Opposite' },
    { value: 'libero', label: 'Libero' }
  ],
  default: [
    { value: 'athlete', label: 'Athlete' }
  ]
};

export const EXPERIENCE_LEVELS = [
  { value: 'beginner', label: 'Beginner (0-1 years)' },
  { value: 'intermediate', label: 'Intermediate (2-4 years)' },
  { value: 'advanced', label: 'Advanced (5-7 years)' },
  { value: 'elite', label: 'Elite (8+ years)' }
];

export const TRAINING_FREQUENCIES = [
  { value: '1-2', label: '1-2 times per week' },
  { value: '3-4', label: '3-4 times per week' },
  { value: '5-6', label: '5-6 times per week' },
  { value: 'daily', label: 'Daily' }
];
